import styled from "styled-components";

const CreateStyle = styled.div`
  .badge-border-suc {
    border-radius: 20px;
    border: 1px solid #00ff00;
    cursor: pointer;
  }
  .max-width {
    max-width: 500px !important;
  }
  td {
    max-width: 500px !important;
  }
  .table-row {
    display: table-row;
  }
  .demo-editor {
    background: #fff;
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 0 15px;
    min-height: 200px;
    resize: vertical;
  }
  .public-DraftStyleDefault-block {
    margin-bottom: 1em;
  }
`;

export default CreateStyle;



// WEBPACK FOOTER //
// ./src/Pages/Create/Wrapper.js